<template>
  <section>
    <KpiCards
      class="mb-3"
      :items="kpiItems"
      :loading="loadingSummary"
      :skeleton="4"
    />

    <data-table
      :headers="headers"
      :items="users"
      commit="SET_USERS"
      :viewItem="viewItem"
    >
      <div slot="activator" class="row justify-content-between mb-4">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-2">
          <v-card-title class="px-0 pt-0 ps-products-title">
            {{ $t("user") }}
          </v-card-title>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-3 offset-lg-7">
          <TextSearch
            v-model="search"
            @search="fetchItem()"
            @onClear="
              search = '';
              fetchItem();
            "
          />
        </div>
      </div>
    </data-table>

    <app-custom-dialog v-model="dialog" :footer="false" title="description">
      <div slot="activator">
        <v-row>
          <v-col cols="12" class="pb-0">
            <div class="text-subtitle-1 font-weight-medium">
              {{ form.first_name }} {{ form.last_name }}
            </div>
            <div class="text-body-2 grey--text">{{ form.email || "-" }}</div>
          </v-col>
          <v-col cols="12" class="pt-0"><v-divider /></v-col>

          <v-col cols="4" class="grey--text">{{ $t("id") }}</v-col>
          <v-col cols="8" class="text-right font-weight-medium">{{
            form.id
          }}</v-col>
          <v-col cols="4" class="grey--text">{{ $t("phone_no") }}</v-col>
          <v-col cols="8" class="text-right">{{ form.phone_no || "-" }}</v-col>
          <v-col cols="4" class="grey--text">{{ $t("role") }}</v-col>
          <v-col cols="8" class="text-right">
            <v-chip
              dark
              :color="RoleColor(form.role)"
              small
              class="text-capitalize"
              label
            >
              {{ userRole(form.role) }}
            </v-chip>
          </v-col>
          <v-col cols="4" class="grey--text">{{ $t("branch") }}</v-col>
          <v-col cols="8" class="text-right">{{
            (form.branch_id && form.branch_id.name) || "-"
          }}</v-col>
          <v-col cols="4" class="grey--text">{{ $t("status") }}</v-col>
          <v-col cols="8" class="text-right">
            <v-chip label dark small :color="form.is_active ? 'green' : 'red'">
              {{ form.is_active ? $t("active") : $t("inactive") }}
            </v-chip>
          </v-col>
          <v-col cols="4" class="grey--text">{{ $t("date") }}</v-col>
          <v-col cols="8" class="text-right">{{ form.created_at | moment }}</v-col>
        </v-row>
      </div>
    </app-custom-dialog>
  </section>
</template>

<script>
import DataTable from "@/components/DataTable";
import { mapGetters, mapActions } from "vuex";
import { myMixin } from "@/mixin/main";
import { adminStoreSummary } from "@/mixin/adminStoreSummary";

export default {
  mixins: [myMixin, adminStoreSummary],
  components: { DataTable },
  data: () => ({
    dialog: false,
    search: "",
    form: {},
  }),
  async created() {
    await Promise.all([this.fetchItem(), this.fetchSummary("users")]);
  },
  computed: {
    ...mapGetters({
      users: "index/users",
    }),
    headers() {
      return [
        { text: this.$t("id"), value: "index" },
        { text: this.$t("avatar"), value: "avatar" },
        { text: this.$t("first_name"), value: "first_name" },
        { text: this.$t("role"), value: "userRole" },
        { text: this.$t("branch"), value: "branch_id.name" },
        { text: this.$t("phone_no"), value: "phone_no" },
        { text: this.$t("email"), value: "email" },
        { text: this.$t("status"), value: "statusUser" },
        { text: this.$t("date"), value: "created_at", align: "right" },
        { text: this.$t("manage"), value: "actions", align: "right" },
      ];
    },
  },
  methods: {
    ...mapActions({
      fetch: "index/fetch",
    }),
    async fetchItem() {
      const { store_id } = this.$route.params;
      const body = {
        that: this,
        url: `get_shop_users/${store_id}?q=${encodeURIComponent(this.search || "")}`,
        commit: "SET_USERS",
      };
      await this.fetch(body);
    },
    // the row already carries everything shown; get_user_detail is an owner endpoint
    // (needs a tenant context), so the admin view doesn't call it.
    viewItem(item) {
      this.form = item;
      this.dialog = !this.dialog;
    },
  },
};
</script>

<style scoped>
.ps-products-title {
  font-size: 1.25rem;
  font-weight: 900;
  color: #141021;
}
</style>
